(() => {
  if (customElements.get('lds-quick-custom-request')) return;
  const requests = new Map();
  class QuickCustomRequest extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.init());
    }
    init() {
      if (this.field) return;
      const form = document.getElementById(this.dataset.formId);
      const variants = JSON.parse(this.querySelector('script').textContent);
      if (!form || !variants.some(v => v.options.some(o => /^custom\b/i.test(o)))) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.field = document.createElement('textarea');
      this.field.name = 'properties[Custom design request]';
      this.field.id = `${this.dataset.formId}-custom-text`;
      this.field.rows = 3;
      this.field.maxLength = 500;
      this.field.value = requests.get(this.dataset.productId) || '';
      this.field.placeholder = 'Your text or a short description of your logo';
      const label = document.createElement('label');
      label.htmlFor = this.field.id;
      label.textContent = 'Your logo or text *';
      this.className = 'lds-quick-custom-request';
      this.append(label, this.field);
      form.prepend(this);
      const update = () => {
        const id = form.querySelector('[name="id"]')?.value;
        const variant = variants.find(v => String(v.id) === id);
        const custom = !!variant?.options.some(o => /^custom\b/i.test(o));
        this.hidden = !custom;
        this.field.disabled = !custom;
        this.field.required = custom;
        this.field.setCustomValidity('');
      };
      form.addEventListener('variant:change', update, {signal});
      this.field.addEventListener('input', () => {
        requests.set(this.dataset.productId, this.field.value);
        this.field.setCustomValidity('');
      }, {signal});
      form.addEventListener('submit', event => {
        update();
        if (!this.field.disabled && !this.field.value.trim()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.field.setCustomValidity('Please enter your text or describe your logo.');
          this.field.reportValidity();
        }
      }, {capture: true, signal});
      update();
    }
    disconnectedCallback() {
      queueMicrotask(() => { if (!this.isConnected) this.controller?.abort(); });
    }
  }
  customElements.define('lds-quick-custom-request', QuickCustomRequest);
})();

/* Keep native actions in the general hub when it imports legacy brand cards. */
(() => {
  function init() {
    const hub = document.querySelector('[data-badge-hub]');
    const grid = hub?.querySelector('[data-badge-hub-products], [data-badge-products]');
    const original = grid?.querySelector('.lds-badge-card__actions');
    if (!grid || !original || grid.dataset.badgeQuickBound) return;
    grid.dataset.badgeQuickBound = 'true';
    const template = original.cloneNode(true);
    const enhance = () => {
      for (const old of grid.querySelectorAll('a.lds-plate-collection__product[data-product-id]')) {
        const image = old.querySelector('.lds-plate-collection__product-image');
        const body = old.querySelector('.lds-plate-collection__product-body');
        const handle = new URL(old.href).pathname.match(/\/products\/([^/]+)/)?.[1];
        if (!image || !body || !handle) continue;
        const card = document.createElement('article');
        for (const attr of old.attributes) if (attr.name !== 'href') card.setAttribute(attr.name, attr.value);
        card.classList.add('lds-plate-collection__product--quick-actions');
        card.setAttribute('data-badge-quick-actions', '');
        const media = document.createElement('div');
        media.className = 'lds-badge-card__media hdt-pr-style8';
        const link = document.createElement('a'); link.href = old.href;
        link.className = 'lds-badge-card__image-link'; link.append(image.cloneNode(true));
        const actions = template.cloneNode(true);
        for (const button of actions.querySelectorAll('button')) {
          button.setAttribute('handle', handle); button.setAttribute('aria-expanded', 'false');
        }
        const info = document.createElement('a'); info.href = old.href;
        info.className = 'lds-plate-collection__product-link'; info.append(body.cloneNode(true));
        media.append(link, actions); card.append(media, info); old.replaceWith(card);
      }
    };
    new MutationObserver(enhance).observe(grid, {childList:true});
    enhance();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
